import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {formatRoute} from 'react-router-named-routes';

import {Group} from "../../../shared/components/Group";
import {
  FEEDBACK_FUNNY,
  FEEDBACK_HAPPY,
  FEEDBACK_LOVE,
  FEEDBACK_LUCKY,
  FEEDBACK_POSITIVE,
  FEEDBACK_RECEIVED,
  FEEDBACK_YES
} from "../constants";
import {showImageAction} from "../../image/actions/imageAction";
import * as notificationAction
  from "../../../shared/modules/notification/actions/notificationsAction";
import {NOTIFICATION_WARNING} from "../../../shared/modules/notification/constants";
import {ROUTER_IMAGE_DETAIL} from "../../../shared/constants/routers";
import {IMAGE_PERMISSION_RWE} from "../../../shared/constants/image";
import Feedback from "./Feedback";

const Parser = require('html-react-parser');


class TimelineItemBody extends React.Component {

  static propTypes = {
    image: PropTypes.shape({
      url: PropTypes.string.isRequired,
      hash: PropTypes.string.isRequired
    }),
    title: PropTypes.string.isRequired,
    feedback: PropTypes.string.isRequired,
    rights: PropTypes.number.isRequired,
    recipient: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired
    })
  };

  onClick = (evt) => {
    evt.preventDefault();
    if (this.props.image.hash) {
      this.props.dispatch(
        showImageAction(
          this.props.image.hash,
          this.props.image.url,
          this.props.title,
          this.props.rights,
          [this.props.recipient.id],
          this.props.feedback ? [this.props.feedback] : []
        )
      );
      this.props.history.push(formatRoute(ROUTER_IMAGE_DETAIL, {imageHash: this.props.image.hash}));
    } else {
      this.props.dispatch(
        notificationAction.addNotification(
          __("Please wait until we have processed your image."),
          NOTIFICATION_WARNING
        )
      );
    }
  };

  /**
   * Gets feedback component
   * @param {string} icon - should start with "fa"
   * @param {string} state - feedback state
   * @return {Feedback} component
   */
  getFeedbackComponent(icon, state) {
    return (
      <Feedback icon={icon}>
        <b>{this.props.recipient.name}</b> {state}
      </Feedback>
    );
  }

  /**
   * Gets feedback
   * @param {string} info - feedback or transmission state
   * @return {Feedback} component
   */
  getFeedback(info) {
    switch (info) {
      case FEEDBACK_RECEIVED:
        return this.getFeedbackComponent(
          "fa-check",
          __("has received the picture")
        );
      case FEEDBACK_YES:
        return this.getFeedbackComponent(
          "fa-thumbs-up",
          Parser(__("answered <b>yes</b>"))
        );
      case FEEDBACK_HAPPY:
        return this.getFeedbackComponent(
          "fa-smile-o",
          Parser(__("was <b>happy</b>"))
        );
      case FEEDBACK_LOVE:
        return this.getFeedbackComponent(
          "fa-heart",
          Parser(__("<b>loves</b> the picture"))
        );
      case FEEDBACK_FUNNY:
        return this.getFeedbackComponent(
          "fa-smile-o",
          Parser(__("find the picture <b>funny</b>"))
        );
      case FEEDBACK_LUCKY:
        return this.getFeedbackComponent(
          "fa-sun-o",
          Parser(__("make the picture <b>happy</b>"))
        );
      case FEEDBACK_POSITIVE:
        return this.getFeedbackComponent(
          "fa-thumbs-up",
          Parser(__("<b>thanked</b> for the picture"))
        );
      default:
        return null;
    }
  }

  render() {
    return (
      <div className="timelineBody">
        <Group>
          {this.props.title &&
          this.props.title.length > 0 &&
          <div
            className="message"
            dangerouslySetInnerHTML={{__html: this.props.title}}
          />
          }
          {this.props.image.url &&
          this.props.image.url.length > 0 &&
          <div className="timelineImage"
               style={{
                 backgroundImage: `url(${this.props.image.url})`
               }}
               onClick={this.onClick}
          >
            {this.props.rights === IMAGE_PERMISSION_RWE &&
            <div className="imageDeletion">
              <i className="fa fa-trash"/>
            </div>
            }
            </div>
          }
          <div className="info">
            <ul>
              {this.getFeedback(this.props.feedback)}
            </ul>
          </div>
          {!this.props.image.hash &&
          <div className="pendingOverlay"/>
          }
        </Group>
      </div>
    );
  }
}

export default withRouter(connect()(TimelineItemBody));
